import { StyleSheet } from "react-native";

export default StyleSheet.create({
    Maincontainer : {
        padding :10,
        justifyContent :'center',
        alignItems :'center',

    },
    starImage : {
        width:25,
        height:25,
        padding:5,
        marginHorizontal:5,
      },
      starView: {
        flexDirection:'row',
      },
});
